export function queryParam(name, search = window.location.search) {
  return (
    search
      .replace("?", "")
      .split("&")
      .map((param) => param.split("="))
      .filter((param) => param[0] === name)?.[0]?.[1] || ""
  );
}
